/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetReportDefinitionByIdQueryResponse, GetReportDefinitionByIdPathParams, GetReportDefinitionById404 } from "../models/GetReportDefinitionById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getReportDefinitionById } from "../axios/getReportDefinitionById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getReportDefinitionByIdQueryKey = (id: GetReportDefinitionByIdPathParams["id"]) => ["audit-reports-api", { url: '/report-definitions/by-id/:id', params: {id:id} }] as const

export type GetReportDefinitionByIdQueryKey = ReturnType<typeof getReportDefinitionByIdQueryKey>

export function getReportDefinitionByIdQueryOptions(id: GetReportDefinitionByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getReportDefinitionByIdQueryKey(id)
        return queryOptions<GetReportDefinitionByIdQueryResponse, ResponseErrorConfig<GetReportDefinitionById404>, GetReportDefinitionByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getReportDefinitionById(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves a specific report definition by its unique identifier
 * @summary Get report definition by ID
 * {@link /report-definitions/by-id/:id}
 */
export function useGetReportDefinitionById<TData = GetReportDefinitionByIdQueryResponse, TQueryData = GetReportDefinitionByIdQueryResponse, TQueryKey extends QueryKey = GetReportDefinitionByIdQueryKey>(id: GetReportDefinitionByIdPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetReportDefinitionByIdQueryResponse, ResponseErrorConfig<GetReportDefinitionById404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getReportDefinitionByIdQueryKey(id)
         

         const query = useQuery({
          ...getReportDefinitionByIdQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetReportDefinitionById404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}